import { CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { RbacService } from '../rbac/rbac.service';
import { AuthStore } from '../store/auth-store.service';

export const guestGuard: CanMatchFn = (route, segments) => {
  const router = inject(Router);
  const authStore = inject(AuthStore);
  const rbacService = inject(RbacService);

  const isAuthenticated = authStore.isAuthenticated();
  // Ask RBAC, not whether the user has any role: controlHubAuthGuard sends a
  // user without access here, so redirecting it to /dashboard would loop.
  const hasAccess = rbacService.hasAccess();

  // If authenticated with access, redirect to dashboard
  if (isAuthenticated && hasAccess) {
    return router.createUrlTree(['/dashboard']);
  }

  // If authenticated without access and trying to access login, redirect to unauthorized
  if (isAuthenticated && !hasAccess && route.path === 'auth/login') {
    return router.createUrlTree(['/auth/unauthorized']);
  }

  return true;
};
